/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsXyVUpIcon64Regular = forwardRef('DataChartBarsXyVUpIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M7.5 8A1.5 1.5 0 0 1 9 9.5v39a5.5 5.5 0 0 0 5.5 5.5h42a1.5 1.5 0 0 1 0 3h-42A8.5 8.5 0 0 1 6 48.5v-39A1.5 1.5 0 0 1 7.5 8Z" }),
        React.createElement("path", { d: "M19.5 32a1.5 1.5 0 0 1 1.5 1.5v11a1.5 1.5 0 0 1-3 0v-11a1.5 1.5 0 0 1 1.5-1.5Z" }),
        React.createElement("path", { d: "M41 19.5a1.5 1.5 0 0 0-3 0v25a1.5 1.5 0 0 0 3 0v-25Z" }),
        React.createElement("path", { d: "M49.5 11a1.5 1.5 0 0 1 1.5 1.5v32a1.5 1.5 0 0 1-3 0v-32a1.5 1.5 0 0 1 1.5-1.5Z" }),
        React.createElement("path", { d: "M31 26.5a1.5 1.5 0 0 0-3 0v18a1.5 1.5 0 0 0 3 0v-18Z" })));
});
